import {useEffect} from "react";
import isEmpty from "is-empty";
import classNames from "classnames";
import {BaseLayout} from "@/app/layouts";
import {CatalogBreadcrumbs} from "@/features/catalog-breadcrumbs";
import {Picture} from "@/shared/ui/Picture";
import {CatalogCard} from "@/widgets/catalog-card";
import {CatalogShowMore} from "@/widgets/catalog-show-more";
import {CatalogTags} from "@/widgets/catalog-tags";
import {CatalogFilters} from "@/widgets/catalog-filters";
import {CatalogFilterDrawer} from "@/widgets/catalog-filter-drawer";
import {CatalogFiltersDrawer, useCatalogFiltersDrawer} from "@/widgets/catalog-filters-drawer";
import styles from "./ui/Index.module.scss";
import useViewItemBatcher from "@/Hooks/useViewItemBatcher"; // Legacy
import {lazyWithPreload} from "@/Helpers/lazyWithPreload"; // Legacy
import LazySection from "@/Components/LazySection"; // Legacy
import useWithStore from "@/Hooks/useWithStore"; // Legacy
import {useStoreMobx} from "@/shared/lib/mobx/useStoreMobx"; // Legacy

const Pagination = lazyWithPreload(() =>
    import('@/shared/ui/Pagination').then(module => ({
        default: module.Pagination,
    })),
);

const Index = (props) => {
    const {
        h1 = '',
        images = {},
        products = [],
        isMobile = false,
        count = 0,
        seoText = '',
        tagOne = [],
        filters = [],
        dataSort = [],
        insertColors = [],
        isDesktop = false,
        selectedFilters = []
    } = props;

    const openModalCatalogFilters = useCatalogFiltersDrawer(s => s.actions.openModal);

    const {catalogStore = {}} = useStoreMobx();

    const sectionClasses = classNames(styles.section, {[styles.offset]: !isEmpty(images)});

    const {registerView} = useViewItemBatcher();

    useEffect(() => {
        catalogStore.start(props);
    }, [products]);

    useEffect(() => {
        catalogStore.startFilters(props);
    }, []);

    return (
        <BaseLayout>
            <div className={sectionClasses}>
                {!isEmpty(images) && (
                    <div className={styles.catalogImage}>
                        <Picture src={images.img_path} srcMobile={images.img_mobile_path} alt={h1} />
                    </div>
                )}
                <div className={`globalContainer`}>
                    <CatalogBreadcrumbs
                        selectedFilters={selectedFilters}
                    />
                    <div className={styles.catalog}>
                        <div className={styles.titleContainer}>
                            <h1 className={styles.title}>{h1}</h1>
                            {count !== 0 && (
                                <p className={styles.count}>
                                    | Найдено {count.toLocaleString('ru')}
                                </p>
                            )}
                        </div>
                        <div className={styles.inner}>
                            <CatalogFilters
                                filters={filters}
                                dataSort={dataSort}
                                insertColors={insertColors}
                                isDesktop={isDesktop}
                                selectedFilters={selectedFilters}
                                onOpen={openModalCatalogFilters}
                            />
                            <div className={styles.catalogCards}>
                                {count !== 0 ?
                                    <>
                                        {products.map((product, i) => {
                                            return (
                                                <CatalogCard
                                                    key={product.id}
                                                    product={product}
                                                    mediaVariant={`slider`}
                                                    // variant={`withShadow`}
                                                    className={styles.card}
                                                    index={(catalogStore.page - 1) * catalogStore.perPageStart + i + 1}
                                                    registerView={registerView}
                                                />
                                            );
                                        })}
                                    </>
                                    :
                                    <>
                                        Не удалось найти украшения с указанными параметрами. Попробуйте сбросить
                                        фильтры.
                                    </>
                                }
                            </div>
                            {count > catalogStore.perPageStart && (
                                <div className={styles.paginationContainer}>
                                    <CatalogShowMore />
                                    <LazySection>
                                        <Pagination
                                            activePage={catalogStore.activePage}
                                            totalItemsCount={count}
                                            pageRangeDisplayed={isMobile ? 4 : 10}
                                            itemsCountPerPage={catalogStore.perPageStart}
                                            onChange={catalogStore.handlePageChange}
                                            hideFirstLastPages={isMobile}
                                        />
                                    </LazySection>
                                </div>
                            )}
                            {(seoText !== '') && (<p className={styles.seoText}>{seoText}</p>)}
                            <CatalogTags tags={tagOne} />
                        </div>
                    </div>
                </div>
            </div>
            <CatalogFilterDrawer />
            <CatalogFiltersDrawer />
        </BaseLayout>
    )
}

export default useWithStore(Index);
